import { render, staticRenderFns } from "./APISettingResource.vue?vue&type=template&id=a98272e4&"
import script from "./APISettingResource.vue?vue&type=script&lang=js&"
export * from "./APISettingResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports